import React, { useState, useEffect } from "react";
import Header from "../../component/loaderComponent/Header/Header";
import Sidebar from "../Sidebar";
import './Editrewaedredeem.scss'
import { useNavigate } from "react-router-dom";
import { notify } from '../../services/notification';
import { useParams } from "react-router-dom";
import { decode } from "base-64";
import { productcodemappingDetailAction, posteditrewardredeemAction } from "../../actions/rewardAction";
import { useDispatch } from "react-redux";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import Validation from "../../constants/validation/Validation";
import { HiMenu, HiX } from "react-icons/hi";
import { MOBILE_BREAKPOINT, HTTP_STATUS } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";


function EditRewardRedeem() {
  const [states, setDataStates] = useState({
    unique_id: "",
    amount: "",
    product_code: "",
    product_description: "",
    points: ""
  });
  const { id } = useParams();
  const { isSidebarOpen, toggleSidebar } = useMobileView();

  const product_code_mapping_id = decode(id)
  const [loading, setloading] = useState(false);

  const [error, setError] = useState({
    amount_error: "",
  })
  let validateForm = () => {
    let formIsValid = true;
    if (states?.points?.length == "") {
      setError({ amount_error: "Please enter reward amount" });
      formIsValid = false;
    } else {
      setError({});
    }
    return formIsValid;
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    getRewardsDetailData();
  }, []);



  async function getRewardsDetailData() {
    setloading(true);
    var response = await dispatch(productcodemappingDetailAction(product_code_mapping_id));
    if (response.status === 200) {
      setDataStates({
        ...states,
        product_code: response.data.data.product_code,
        product_description: response.data.data.product_description,
        points: response.data.data.points
      })
      setloading(false);
    } else if (response === undefined) {
      setloading(false);
    }

  }

  const handlecancelbutton = () => {
    navigate("/rewardredeem")
  }

  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
  };

  const handleonsubmitclick = async () => {
    if (validateForm()) {
      setloading(true);
      const apiReq = {
        points: states.points
      }
      let response = await dispatch(posteditrewardredeemAction(apiReq, product_code_mapping_id));
      if (response.status === 200) {
        notify.success(response.data.messsge)
        setloading(false);
        navigate("/rewardredeem")
      } else if (response === undefined) {
        setloading(false);
      }
    }
  }

  return (
    <div className="edit_rewardredeem_conatiner">
      <div className="edit_rewardredeem_conatiner_right">
        <Header title="Edit Reward Amount" />
        {loading ? <Loader /> : (
          <div className="edit_reward_redeem_containers">
            <div className="edit_reward_redeem">
              <label className="lable_edit_reward_redeem">Coupon Variable</label>
              <input className="edit_reward_redeem_input" type="text" maxLength={4} minLength={4} placeholder="Coupon Variable" name="product_code" readOnly value={states.product_code} />
            </div>
            <div className="edit_reward_redeem">
              <label className="lable_edit_reward_redeem">Description</label>
              <input className="edit_reward_redeem_input" type="text" placeholder="Product Description" name="product_description" readOnly value={states.product_description} />
            </div>
            <div className="edit_reward_redeem">
              <label className="lable_edit_reward_redeem">Reward Amount</label>
              <input className="edit_reward_redeem_input" type="text" placeholder="Amount" name="points" value={states.points} onChange={handleChange} onKeyPress={(e) => Validation.numberinputValidator(e)} />
            </div>
            {error && <div className="amount_error_message">{error.amount_error}</div>}
            <div className="edit_reward_redeem_button">
              <button className="edit_reward_redeem_Submit_button" onClick={handleonsubmitclick}>Submit</button>
              <button className="edit_reward_redeem_Add_button" onClick={handlecancelbutton}>Cancel</button>
            </div>
          </div>)}
      </div>
    </div>
  )
}
export default EditRewardRedeem;